/* eslint-disable */
/**
 * 该文件是为了按需加载，剔除掉了一些不需要的框架组件。vant的模板懒加载
 * 减少了编译支持库包大小
 *
 * 当需要更多组件依赖时，在该文件加入即可
 */
import Vue from 'vue'

import {
  Toast,
  Button,
  Popup,
  Form,
  Field,
  Picker,
  RadioGroup,
  Cell,
  CellGroup,
  Radio,
  Divider,
  Switch,
  Icon,
  Grid,
  GridItem,
  DatetimePicker,
  TreeSelect,
  Badge,
  Slider,
  Calendar,
  Checkbox,
  ActionSheet,
  Tag,
  Area,
  Empty,
  DropdownMenu,
  DropdownItem,
  Pagination,
  Search,
  Steps,
  Step,
  Uploader,
  Dialog,
  CheckboxGroup,
  Swipe,
  SwipeItem,
  Tabs,
  Tab,
  NoticeBar
} from 'vant'

Vue.use(Button)
Vue.use(Popup)
Vue.use(Form)
Vue.use(Field)
Vue.use(Picker)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Divider)
Vue.use(Switch)
Vue.use(Icon)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(DatetimePicker)
Vue.use(TreeSelect)
Vue.use(Badge)
Vue.use(Slider)
Vue.use(Calendar)
Vue.use(Checkbox)
Vue.use(ActionSheet)
Vue.use(Tag)
Vue.use(Area)
Vue.use(Empty)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Pagination)
Vue.use(Search)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Uploader)
Vue.use(CheckboxGroup)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(NoticeBar)
Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
